import React from 'react'
import Clients from '../Clients/Clients'
import ContactMe from '../ContactMe/ContactMe'
import Header from '../Header/Header'
import Info from '../Info/Info'
import Landing from '../Landing/Landing'
import About from '../About/About'
import Projects from '../Projects/Projects'

const Home = () => {
  return (
    <div>
      <Header/>
      <Landing/>
      <About/>
      <Projects/>
      <Info/>
      <Clients/>
      <ContactMe/>
    </div>
  )
}

export default Home
